import { configureStore } from "@reduxjs/toolkit";
import breadCrumbsSlice from "./breadCrumbs/breadCrumbsSlice";

export default configureStore({
  reducer: {
    breadCrumbs: breadCrumbsSlice,
    // Add redux file here
  },
});
